import { memo } from 'react';
import PropTypes from 'prop-types';

import { Title } from '~/components';

import styles from './EditAppointmentTitle.scss';

export const EditAppointmentTitle = memo(({ title = 'Appointment details' }) => (
  <Title data-testid="EditAppointmentTitle" className={styles.lined}>
    {title}
  </Title>
));

EditAppointmentTitle.propTypes = {
  title: PropTypes.string,
};
